import React, { useState } from "react";
import Input from "../../atoms/Input/Input";
import useRequest from "../../../context/useRequest";
import { useAuth } from "../../../context/AuthContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";

const ChangePasswordForm = () => {
  const navigate = useNavigate();
  const { sendRequest } = useRequest();
  const { userId } = useAuth();

  const [changePasswordData, setChangePasswordData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [isFieldErrors, setIsFieldErrors] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const changePasswordHandler = (e) => {
    const { name, value } = e.target;

    setChangePasswordData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setIsFieldErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validatePasswordFields = () => {
    const errors = {};
    const { old_password, new_password, confirm_password } = changePasswordData;

    // Old password validation
    if (!old_password.trim()) {
      errors.old_password = "Old password is required";
    }

    // New password validations
    const newPasswordErrors = [];
    if (!new_password) {
      newPasswordErrors.push("New password is required");
    } else {
      if (new_password.length < 8) {
        newPasswordErrors.push("Password must be at least 8 characters");
      }
      if (!/[A-Z]/.test(new_password)) {
        newPasswordErrors.push("Must include at least one uppercase letter");
      }
      if (!/[a-z]/.test(new_password)) {
        newPasswordErrors.push("Must include at least one lowercase letter");
      }
      if (!/[0-9]/.test(new_password)) {
        newPasswordErrors.push("Must include at least one number");
      }
      if (!/[!@#$%^&*]/.test(new_password)) {
        newPasswordErrors.push("Must include at least one special character (!@#$%^&*)");
      }
      if (/\s/.test(new_password)) {
        newPasswordErrors.push("Password must not contain spaces");
      }
    }
    if (newPasswordErrors.length > 0) {
      errors.new_password = newPasswordErrors.join(", ");
    }

    // Confirm password validation
    if (!confirm_password) {
      errors.confirm_password = "Please confirm your password";
    } else if (new_password !== confirm_password) {
      errors.confirm_password = "Confirm password must match new password";
    }

    setIsFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const forgotSubmitHandler = async (e) => {
    e.preventDefault();

    const isValid = validatePasswordFields();
    if (!isValid) return;

    const formChangePassword = {
      user_id: userId,
      old_password: changePasswordData.old_password,
      new_password: changePasswordData.new_password,
      confirm_password: changePasswordData.confirm_password,
      vfsGlobalId: "105",
    };

    try {
      const response = await sendRequest({
        method: "POST",
        url: "/auth/changePassword",
        body: formChangePassword,
      });

      if (response.status === true) {
        Swal.fire({
          title: "Password updated successfully",
          icon: "success",
        }).then(() => {
          navigate("/profile");
        });
      } else {
        Swal.fire({
          title: "Old password is incorrect",
          icon: "error",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Old password is incorrect",
        icon: "error",
      });
    }
  };

  return (
    <form
      onSubmit={forgotSubmitHandler}
      className="login-form--item-left-form mt-4"
    >
      <div className="form-group input-group login-form--item-left-form-input">
        <Input
          type="password"
          name="old_password"
          placeholder="Old Password"
          value={changePasswordData.old_password}
          onChange={changePasswordHandler}
          className="form-control"
          label={
            <span>
              Old Password <span style={{ color: "red" }}>*</span>
            </span>
          }
        />
        {isFieldErrors.old_password && (
          <p className="error-message">{isFieldErrors.old_password}</p>
        )}
      </div>

      <div className="form-group input-group login-form--item-left-form-input">
        <Input
          type="password"
          name="new_password"
          placeholder="New Password"
          value={changePasswordData.new_password}
          onChange={changePasswordHandler}
          className="form-control"
          label={
            <span>
              New Password <span style={{ color: "red" }}>*</span>
            </span>
          }
        />
        {isFieldErrors.new_password && (
          <p className="error-message">{isFieldErrors.new_password}</p>
        )}
      </div>

      <div className="form-group input-group login-form--item-left-form-input">
        <Input
          type="password"
          name="confirm_password"
          placeholder="Confirm New Password"
          value={changePasswordData.confirm_password}
          onChange={changePasswordHandler}
          className="form-control"
          label={
            <span>
              Confirm New Password <span style={{ color: "red" }}>*</span>
            </span>
          }
        />
        {isFieldErrors.confirm_password && (
          <p className="error-message">{isFieldErrors.confirm_password}</p>
        )}
      </div>

      <div className="form-group login-form--item-left-form-submit">
        <button type="submit" className="submit">
          Change Password
        </button>
      </div>
    </form>
  );
};

export default ChangePasswordForm;
